<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Detalhes da Corporação</strong>
        </div>
        <b-form @submit.stop.prevent>
        <b-form-group label="Nome" label-for="name">
          <b-form-input disabled id="name" type="text" autocomplete="name" v-model="corporation.name"></b-form-input>
        </b-form-group>

        <b-form-group label="CNPJ" label-for="cnpj">
          <b-form-input disabled id="cnpj" type="text" autocomplete="cnpj" v-model="corporation.cnpj"></b-form-input>
        </b-form-group>
        
        <b-form-group label="Aplicações">
          <hr>
          <b-row>
            <b-col sm="12" lg="3" v-for="(itm) in applications" v-bind:key="itm.clientId">
              <b-card class="text-center card-list">
                <b-card-text class="">
                  <span class="clientID">{{itm.clientId}}</span><br>
                  <b>{{itm.providerEnvironment.toUpperCase()}}</b>
                </b-card-text>
                <b-row>
                  <b-col sm="12" lg="12" class="p-1">
                    <b-button class="form-control" href="#" variant="info" size="sm" @click="toMonitor(itm.clientId)">Monitor</b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-modal
            id="modal-add-app"
            ref="modal"
            title="Adicionar aplicação"
            @show="resetApplicationModal"
            @hidden="resetApplicationModal"
            @ok="handleOkApplication"
          >
            <form ref="form" @submit.stop.prevent="handleSubmitApplication">
              <b-form-group label="Id do Cliente" label-for="app-client-id">
                <b-form-input id="app-client-id" v-model="application.clientId"></b-form-input>
              </b-form-group>
              <b-form-group label="Ambiente" label-for="app-provider-environment">
                <b-form-select v-model="application.providerEnvironment" id="app-provider-environment">
                  <option value="vault">Vault</option>
                  <option value="bird">Bird</option>
                </b-form-select>
              </b-form-group>
            </form>
          </b-modal>
        </b-form-group>
        
        <div slot="footer">
          <b-row>
            <b-col sm="12" lg="2">
              <b-button class="form-control" type="button" variant="secondary" @click="goBack"><i class="fa fa-arrow-left"></i> Voltar</b-button>&nbsp;
            </b-col>
          </b-row>
        </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, formatDate, isAllowed } from '@/shared/utils';
import _ from 'underscore';
import { mapActions } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Corporation',
  components: {
    Loading
  },
  props: {
    caption: {
      type: String,
      default: 'Corporação'
    },
  },
  data: () => {
    return {
      selectLicense: [
        { value: 'withoutReplacement', text: 'Sem substituição' },
        { value: 'activeUser', text: 'Usuário ativo' }, 
        { value: 'bySeat', text: 'Por assento' }
      ],
      selectManagementUserType: [
        { value: 'permissive', text: 'Permissivo' },
        { value: 'restrictive', text: 'Restritivo' }
      ],
      selectExpireType: [
        { value: 'day', text: 'Dia' },
        { value: 'month', text: 'Mês' },
        { value: 'year', text: 'Ano' }
      ],
      selectBillingPeriod: [
        { value: 'monthly', text: 'Mensal' },
        { value: 'semiannually', text: 'Semestral' }, 
        { value: 'yearly', text: 'Anual' }
      ],
      corporation: {
        clientIdsByProvider: {},
        adminUsers: []
      },
      application: {
        clientId: '',
        providerEnvironment: ''
      },
      adminUser: '',
      applications: [],
      loadCount: 0,
      expireTimeDefault: {
        value: null, // Valor inteiro da expressão
        type: null, // Tipo do período (ano, mês, dia)
        final: null // Combinação do valor e o tipo ex: +30 day
      },
      id: ''
    }
  },
  mounted() {
    this.getCorporation(this.$route.params.id);
    this.id = this.$route.params.id;
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    toMonitor(id) {
      this.$router.push('/corporations/monitor/'+ id);
    },

    isAllowed(role) {
      return isAllowed(role);
    },

    ...mapActions(['addCorporation', 'removeCorporation']),
    formatDate(date) {
      return formatDate(date, "dd/MM/yyyy hh:mm");
    },

    resetApplicationModal() {
      this.application = {
        clientId: '',
        providerEnvironment: ''
      }
    },

    handleOkApplication(e) {
      e.preventDefault();
      this.handleSubmitApplication();
    },

    handleSubmitApplication() {
      this.applications.push(this.application);
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
    },

    handleOkAdmin(e) {
      e.preventDefault();
      this.handleSubmitAdmin();
    },

    handleSubmitAdmin() {
      this.corporation.adminUsers.push(this.adminUser);
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
    },

    getCorporation(id) {
      if (!id) {
        return;
      }
      var _this = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/corporation/${id}`)
        .then(function(response) {
          _this.corporation = response.data;
          _this.corporation.autoRenovationDefault = _this.corporation.autoRenovationDefault ? true : false;
          _.mapObject(_this.corporation.clientIdsByProvider, (clients, provider) => {
            clients.forEach((client) => {
              _this.applications.push({ 
                providerEnvironment: provider, 
                clientId: client.clientId
              });
            });
          });
          console.log('_this.corporation :', _this.corporation);
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
.clientID {
  font-size: 16px;
}
@media (min-width: 576px) {
  /* .card-body >>> .card-list {
    max-width: 200px;
  } */
}
</style>